module.exports = __webpack_public_path__ + "media/packs/components/weployer/jobTypeSelectionModal/select_illustration-bb6e7766d4789e9de06dc5644def2fee.svg";